import * as Yup from 'yup';

export type patientExportValueTypes = {
    exportFormat: string;
    facilityCode: string;
    chwId: string;
    patientType: string;
    fromDate: string;
    toDate: string;
};

export const patientInitalValues: patientExportValueTypes = {
    exportFormat: 'CSV',
    facilityCode: '',
    patientType: '',
    chwId: '',
    fromDate: '',
    toDate: '',
};

export const patientExportValidationSchema = Yup.object({
    exportFormat: Yup.string().label('Export format is required'),
    facilityCode: Yup.string().label('Facility name is required'),
    patientType: Yup.string().label('Patient Type is required'),
    chwId: Yup.string().label('CHW name is required'),
    fromDate: Yup.date()
        .required('From date is required')
        .when([], {
            is: (value: any) => value !== undefined,
            then: (schema) =>
                schema.test(
                    'fromDate',
                    'From date is required',
                    function (value) {
                        return this.parent.fromDate !== undefined;
                    }
                ),
        }),
    toDate: Yup.date()
        .required('To date is required')
        .when('fromDate', (fromDate, schema) => {
            return fromDate
                ? schema.required(
                      'To date is required when From date is specified'
                  )
                : schema.nullable();
        })
        .min(Yup.ref('fromDate'), 'To date must be greater than From date')
        .max(new Date(), 'Date must not be more than the current date')
        .when([], {
            is: (value: any) => value !== undefined,
            then: (schema) =>
                schema.test('toDate', 'To date is required', function (value) {
                    return this.parent.toDate !== undefined;
                }),
        }),
});
